import axios from 'axios';
import { getBaseUrl } from '@services/api';

export async function fetchGamePreviewKey(buildId: string, editorKey: string): Promise<string> {
  const apiBase = getBaseUrl().replace(/\/+$/, '');
  const { data } = await axios.get<{ previewKey?: unknown }>(
    `${apiBase}/game-key/by-build/${encodeURIComponent(buildId)}/preview-key`,
    { headers: { 'x-editor-key': editorKey }, withCredentials: true },
  );
  if (typeof data.previewKey !== 'string' || !data.previewKey) {
    throw new Error('Could not create a read-only game link');
  }
  return data.previewKey;
}
